// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getFirestore } from "@firebase/firestore";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqc5HAqJ0m759hLjodsQRmZwXfdeHqKbo",
  authDomain: "ukies-webinars.firebaseapp.com",
  projectId: "ukies-webinars",
  storageBucket: "ukies-webinars",
  messagingSenderId: "1056078927127",
  appId: "1:1056078927127:web:53252fb6f923e020d01352",
  measurementId: "G-CSC9XYL3LS"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

// Authenticate
const auth = getAuth(firebase);

// Initialize everything else
const analytics = getAnalytics(firebase);
const functions = getFunctions(firebase);
const storage = getStorage(firebase);
const db = getFirestore(firebase);

export {firebase, analytics, functions, storage, db, auth}